visitedNode